import React, { useState, useEffect, Fragment } from "react";
import { MdRemoveCircle } from "react-icons/md";
import { FaWindowClose } from "react-icons/fa";
import DropDown from "../Ui/DropDown";
import { apiWrapWithErrorWithData } from "../../utils/apiWrapper";
import {
    createJob,
    getAllMasterProcess,
    getQuotation,
    corporateCompanyJobSaveAsDraft,
    getAllBiometricCenters
} from "../../Redux/Actions/jobs";

import { getAllPaymentTypes } from "../../Redux/Actions/payment";
import LoadingButton from "../../utils/loadingButton";
import BasicTable from "../../utils/basicTable";
import { toastMessage } from "../../utils/toast";
import { Card, Modal, ModalBody, ModalFooter, ModalHeader, OverlayTrigger, Tooltip, Button, ButtonGroup } from "react-bootstrap";
import '../jobs/file.css';
import CONFIG from "../../config";
import { useTranslation } from "react-i18next";

let ID = 1;
const initialRequestJob = {
    id: ID,
    email: '',
    applicationNo: '',
    name: '',
    mobile: '',
    gender: 0,
    emailIsFilled: false,
    applicationNoIsFilled: false,
    nameIsFilled: false,
    emailFormatInvalid: false,
    applicationNoInvalid: false,
    applicationNoMinLength: false,
    applicationNoStartWith01: false,
    mobileInvalid: false,
    mobileIsFilled: false,
    genderIsFilled: false,
};

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const numberRegex = /^\d+$/;

function EmiratesIdCreate({ history }) {
    const [departmentId, setDepartmentID] = useState("");
    const [masterProcessId, setMasterProcessID] = useState("");
    const [processId, setProcessID] = useState("");
    const [departmentList, setDepartmentList] = useState([]);
    const [masterProcessList, setMasterProcessList] = useState([]);
    const [processList, setProcessList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [poNumber, setPoNumber] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [requestJobLoading, setRequestJobLoading] = useState(false);
    const [saveAsDraftLoading, setSaveAsDraftLoading] = useState(false);
    const { t } = useTranslation();

    const [quotation, setQuotation] = useState({
        data: null,
        headers: [],
        rows: [],
    });
    const [requestJob, setRequestJob] = useState({
        isRequestJob: false,
        data: [initialRequestJob],
        id: 1,
    });

    const [departmentIdFlag, setDepartmentIdFlag] = useState(false);
    const [masterProcessIdFlag, setMasterProcessIdFlag] = useState(false);
    const [processIdFlag, setProcessIdFlag] = useState(false);
    const [poNumberFlag, setPoNumberFlag] = useState(false);
    const [paymentType, setPaymentType] = useState(1);
    const [selectedPaymentTypeOption, setSelectedPaymentTypeOption] = useState('');
    const [paymentTypeOptions, setPaymentTypeOptions] = useState({});
    const [validationError, setValidationError] = useState('');
    const [biometricCenters, setBiometricCenters] = useState([]);
    const [selectedCenter, setSelectedCenter] = useState(null);
    const [selectCenterFlag, setSelectCenterFlat] = useState(false);
    useEffect(() => {
        getMasterProcessApi();
        getAllPaymentTypesApi();
        fetchBiometricCenters();
    }, []);

    useEffect(() => {
        if (quotation.data != null) {
            setQuotation((preState) => ({
                ...preState,
                headers: Object.keys(quotation.data),
                rows: [quotation.data],
            }));
        }
    }, [quotation.data]);

    const GenderOptions = [
        { label: 'Male', value: 0 },
        { label: 'Female', value: 1 },
    ];

    const handleList = (key, ID) => {
        let list = [];
        if (key === "department") {
            const selectedDepartment = departmentList.find(({ value }) => value === ID);
            list = selectedDepartment ? selectedDepartment.masterProcess : [];
            list = list.map(({ name, id, process }) => ({
                label: name,
                value: id,
                process: process,
            }));
            list.unshift({ label: "Select Master process", value: 0, process: [] });
            setMasterProcessList(list);

            if (list.length > 1) {
                setMasterProcessID(list[1]);
                const processListData = list[1].process.map(({ name, id }) => ({ label: name, value: id }));
                processListData.unshift({ label: "Select Process", value: 0 });
                setProcessList(processListData);

                if (processListData.length > 1) {
                    setProcessID(processListData[1]);
                } else {
                    setProcessID("");
                }
            } else {
                setMasterProcessID("");
                setProcessList([]);
                setProcessID("");
            }
        } else if (key === "masterProcess") {
            const selectedMasterProcess = masterProcessList.find(({ value }) => value === ID);
            list = selectedMasterProcess ? selectedMasterProcess.process : [];
            list = list.map(({ name, id }) => ({ label: name, value: id }));
            list.unshift({ label: "Select Process", value: 0 });
            setProcessList(list);

            if (list.length > 1) {
                setProcessID(list[1]);
            } else {
                setProcessID("");
            }
        }
    };

    useEffect(() => {
        if (departmentList.length > 0) {
            console.log("CONFIG.jobDepartmentID", CONFIG.jobDepartmentID, CONFIG.apiURL);
            const emiratesDept = processList.find(dep => dep.value === parseInt(CONFIG.jobDepartmentID, 10));
            if (emiratesDept) {
                setProcessID(emiratesDept);
                handleList("department", emiratesDept.value);
            }
        }
    }, [departmentList]);

    const getMasterProcessApi = async () => {
        try {
            const res = await apiWrapWithErrorWithData(getAllMasterProcess());
            const { data } = res.data;
            const configProcessId = parseInt(CONFIG.jobDepartmentID, 10);
            let foundDepartment = null;
            let foundMasterProcess = null;
            let foundProcess = null;
            (data?.department || []).forEach(dep => {
                dep.masterProcess?.forEach(mp => {
                    mp.process?.forEach(proc => {
                        if (proc.id === configProcessId) {
                            foundDepartment = dep;
                            foundMasterProcess = mp;
                            foundProcess = proc;
                        }
                    });
                });
            });
            let departmentsList = (data?.department || []).map(({ name, id, masterProcess }) => ({
                label: name,
                value: id,
                masterProcess: masterProcess,
            }));
            departmentsList.unshift({
                label: "Select Department",
                value: 0,
                masterProcess: [],
            });
            setDepartmentList(departmentsList || []);
            if (foundDepartment && foundMasterProcess && foundProcess) {
                setDepartmentID({ label: foundDepartment.name, value: foundDepartment.id, masterProcess: foundDepartment.masterProcess });
                let masterProcessList = foundDepartment.masterProcess.map(({ name, id, process }) => ({
                    label: name,
                    value: id,
                    process: process,
                }));
                masterProcessList.unshift({ label: "Select Master process", value: 0, process: [] });
                setMasterProcessList(masterProcessList);
                setMasterProcessID({ label: foundMasterProcess.name, value: foundMasterProcess.id, process: foundMasterProcess.process });
                let processList = foundMasterProcess.process.map(({ name, id }) => ({ label: name, value: id }));
                processList.unshift({ label: "Select Process", value: 0 });
                setProcessList(processList);
                setProcessID({ label: foundProcess.name, value: foundProcess.id });
            }
        } catch (error) {
            console.log("getMasterProcessApi", error)
        }
    };

    //Get payment types
    const getAllPaymentTypesApi = async () => {
        try {
            const res = await apiWrapWithErrorWithData(getAllPaymentTypes());
            const { data } = res.data;
            setPaymentTypeOptions((data || []).filter(option => option.value === 1 || option.value === 3));
        } catch (error) {
            console.log("getMasterProcessApi", error)
        }
    };

    const fetchBiometricCenters = async () => {
        try {
            const res = await apiWrapWithErrorWithData(getAllBiometricCenters());
            if (res && res.data && Array.isArray(res.data)) {

                setBiometricCenters(res.data.filter(center => center.isActive == true).map(center => ({ label: center.name, value: center.id })));
            } else {
                setBiometricCenters([]);
            }
        } catch (error) {
            setBiometricCenters([]);
        }
    };

    const setFlag = () => {
        setDepartmentIdFlag(false)
        setMasterProcessIdFlag(false)
        setProcessIdFlag(false)
        setPoNumberFlag(false)
    }
    const handleSubmit = async () => {
        setIsLoading(true);
        let flag = false;
        setFlag();
        if (departmentId.label === undefined) {
            setDepartmentIdFlag(true);
            flag = true;
        }
        if (masterProcessId.label === undefined) {
            setMasterProcessIdFlag(true);
            flag = true;
        }
        if (processId.label === undefined) {
            setProcessIdFlag(true);
            flag = true;
        }
        if (poNumber === '') {
            setPoNumberFlag(true);
            flag = true;
        }
        if (selectedCenter == null) {
            setSelectCenterFlat(true);
            flag = true;
        }
        // Validate all requestJob fields
        requestJob.data.forEach((row, index) => {
            changeRequestJob(index, 'emailIsFilled', false);
            changeRequestJob(index, 'applicationNoIsFilled', false);
            changeRequestJob(index, 'nameIsFilled', false);
            changeRequestJob(index, 'emailFormatInvalid', false);
            changeRequestJob(index, 'applicationNoInvalid', false);
            changeRequestJob(index, 'mobileIsFilled', false);
            changeRequestJob(index, 'genderIsFilled', false);
            if (!row.email) {
                changeRequestJob(index, 'emailIsFilled', true);
                flag = true;
            } else if (!emailRegex.test(row.email)) {
                changeRequestJob(index, 'emailFormatInvalid', true);
                flag = true;
            }
            if (!row.applicationNo) {
                changeRequestJob(index, 'applicationNoIsFilled', true);
                flag = true;
            } else if (!numberRegex.test(row.applicationNo)) {
                changeRequestJob(index, 'applicationNoInvalid', true);
                flag = true;
            } else if (!row.applicationNo.startsWith('01')) {
                changeRequestJob(index, 'applicationNoStartWith01', true);
                flag = true;
            } else if (row.applicationNo.length < 20) {
                changeRequestJob(index, 'applicationNoMinLength', true);
                flag = true;
            } else if (row.applicationNo.length > 25) {
                changeRequestJob(index, 'applicationNoInvalid', true);
                flag = true;
            }
            if (!row.name) {
                changeRequestJob(index, 'nameIsFilled', true);
                flag = true;
            } else if (row.name.length > 100) {
                changeRequestJob(index, 'nameIsFilled', true);
                flag = true;
            }
            if (!row.mobile) {
                changeRequestJob(index, 'mobileIsFilled', true);
                flag = true;
            } else if (!numberRegex.test(row.mobile) || row.mobile.length < 7 || row.mobile.length > 15) {
                changeRequestJob(index, 'mobileInvalid', true);
                flag = true;
            }
            if (row.gender !== 0 && row.gender !== 1) {
                changeRequestJob(index, 'genderIsFilled', true);
                flag = true;
            }
        });
        if (flag) {
            setIsLoading(false);
            return;
        }
        setFlag()
        const payload = {
            departmentId: departmentId?.value,
            masterProcessId: masterProcessId?.value,
            processId: processId?.value,
            jobCount: requestJob.data.length,
            poNumber: poNumber
        };
        try {
            const res = await apiWrapWithErrorWithData(getQuotation(payload));
            const response = res.data;
            if (response.data) {
                setQuotation((preState) => ({ ...preState, data: response?.data }));
                setRequestJob((preState) => ({ ...preState, isRequestJob: true }))
            }
        } catch (error) {
            console.log("handleSubmitCreateQuotation", error);
        }
        setIsLoading(false);
        setShowModal(true);
    };

    const onChange = (index) => (event) => {
        const { name, value } = event.target;
        setRequestJob((preState) => ({
            ...preState,
            data: [
                ...preState.data.slice(0, index),
                {
                    ...preState.data[index],
                    [name]: value,
                    // Clear validation flags when user starts typing/correcting
                    [`${name}IsFilled`]: false,
                    [`${name}Invalid`]: false,
                    ...(name === 'applicationNo' ? {
                        applicationNoMinLength: false,
                        applicationNoStartWith01: false
                    } : {}),
                    ...(name === 'email' ? { emailFormatInvalid: false } : {})
                },
                ...preState.data.slice(index + 1),
            ],
        }));
    };

    const changeRequestJob = (index, name, flag) => {
        setRequestJob((preState) => ({
            ...preState,
            data: [
                ...preState.data.slice(0, index),
                {
                    ...preState.data[index],
                    [name]: flag
                },
                ...preState.data.slice(index + 1),
            ],
        }));
    };

    const onAddHandler = () => {
        setRequestJob((preState) => {
            if (preState.data.length >= 30) {
                toastMessage("error", "Maximum 30 rows allowed.");
                return preState;
            }
            return {
                ...preState,
                data: [
                    ...preState.data,
                    { ...initialRequestJob, id: preState.data.length + 1, email: '', applicationNo: '', name: '', gender: 0 }
                ],
        };
});
};

    const onRemoveHandler = (index) => {
        setRequestJob((preState) => ({
            ...preState,
            data: preState.data.filter((_, i) => i !== index),
        }));
    };

    const handleRequestJob = async () => {
        setRequestJobLoading(true);
        try {
            const [processes] = masterProcessList.filter(masPro => (masPro.value === parseInt(masterProcessId.value, 10)));
            const [formId] = processes?.process?.filter(pro => pro.id === parseInt(processId?.value, 10)) || [];
            if (!formId || !formId.formId) {
                toastMessage("error", "Invalid process or form configuration. Please check your selection.");
                setRequestJobLoading(false);
                return;
            }
            const formData = new FormData();
            formData.append("DepartmentId", departmentId?.value);
            formData.append("MasterProcessId", masterProcessId?.value);
            formData.append("ProcessId", processId?.value);
            formData.append("FormId", formId?.formId);
            formData.append("JobCount", requestJob.data.length);
            formData.append("poNumber", poNumber);
            formData.append("PaymentType", paymentType);
            var i = 0;
            // Reset validation flags
            requestJob.data.forEach((_, index) => {
                changeRequestJob(index, "emailIsFilled", false);
                changeRequestJob(index, "applicationNoIsFilled", false);
                changeRequestJob(index, "nameIsFilled", false);
                changeRequestJob(index, "emailFormatInvalid", false);
                changeRequestJob(index, "applicationNoInvalid", false);
                changeRequestJob(index, "applicationNoMinLength", false);
                changeRequestJob(index, "applicationNoStartWith01", false);
                changeRequestJob(index, "mobileIsFilled", false);
                changeRequestJob(index, "genderIsFilled", false);
            });
            let isFilled = false;
            requestJob.data.forEach(({ email, applicationNo, name, centerId, mobile, gender }, index) => {
                if (email === '') {
                    isFilled = true;
                    changeRequestJob(index, "emailIsFilled", true);
                } else if (!emailRegex.test(email)) {
                    isFilled = true;
                    changeRequestJob(index, "emailFormatInvalid", true);
                }
                if (applicationNo === '') {
                    isFilled = true;
                    changeRequestJob(index, "applicationNoIsFilled", true);
                } else if (!numberRegex.test(applicationNo)) {
                    isFilled = true;
                    changeRequestJob(index, "applicationNoInvalid", true);
                } else if (!applicationNo.startsWith('01')) {
                    isFilled = true;
                    changeRequestJob(index, "applicationNoStartWith01", true);
                } else if (applicationNo.length < 20) {
                    isFilled = true;
                    changeRequestJob(index, "applicationNoMinLength", true);
                } else if (applicationNo.length > 25) {
                    isFilled = true;
                    changeRequestJob(index, "applicationNoInvalid", true);
                }
                if (name === '') {
                    isFilled = true;
                    changeRequestJob(index, "nameIsFilled", true);
                } else if (name.length > 100) {
                    isFilled = true;
                    changeRequestJob(index, "nameIsFilled", true);
                }
                if (mobile === '') {
                    isFilled = true;
                    changeRequestJob(index, "mobileIsFilled", true);
                } else if (!numberRegex.test(mobile) || mobile.length < 7 || mobile.length > 15) {
                    isFilled = true;
                    changeRequestJob(index, "mobileInvalid", true);
                }
                if (gender !== 0 && gender !== 1) {
                    isFilled = true;
                    changeRequestJob(index, "genderIsFilled", true);
                }
                formData.append(`Email[${index}]`, email);
                formData.append(`ApplicationNo[${index}]`, applicationNo);
                formData.append(`Name[${index}]`, name);
                formData.append(`CenterId[${index}]`, selectedCenter?.value);
                formData.append(`Mobile[${index}]`, mobile);
                formData.append(`Gender[${index}]`, gender);
            });
            if (isFilled) {
                setRequestJobLoading(false);
                return;
            }
            const res = await apiWrapWithErrorWithData(createJob(formData));

            if (res.status === 400) {
                let errorMsg = res?.data?.message ? res.data.message : res.Message;
                toastMessage("error", errorMsg);
            } else if (res?.Message != '' && res?.StackTraceString != null) {
                let errorMsg = res?.data?.message ? res.data.message : res.Message;
                setValidationError(errorMsg);
                toastMessage("error", errorMsg);
            } else if (res.status == 200 && res.data.data.isOnlinePayment && paymentType === 1) {
                toastMessage("success", res.data.message);
                history.push(`/checkout/${res.data.data.id}`)
            } else {
                const errorMsg = res.data && res.data.message ? res.data.message : (res.message ? res.message : "An error occurred");
                if (res.data.validations) {
                    const validationErrors = res.data.validations;
                    console.log("Validation Errors:", validationErrors);
                    toastMessage('error', validationErrors.map((err, idx) => `${err}${idx !== validationErrors.length - 1 ? '\n\n' : ''}`).join(''));
                } else {
                     toastMessage("error", errorMsg);
                }
                setShowModal(false);
            }
        } catch (error) {
            console.log("handleRequestJob:", error);
        }
        setRequestJobLoading(false);
    };

    const handleSaveAsDraft = async () => {
        setSaveAsDraftLoading(true);
        try {
            const [processes] = masterProcessList.filter(masPro => (masPro.value === parseInt(masterProcessId.value, 10)));
            const [formId] = processes?.process.filter(pro => pro.id === parseInt(processId?.value, 10));
            const formData = new FormData();
            formData.append("DepartmentId", departmentId?.value);
            formData.append("MasterProcessId", masterProcessId?.value);
            formData.append("ProcessId", processId?.value);
            formData.append("FormId", formId?.formId);
            formData.append("JobCount", requestJob.data.length);
            formData.append("poNumber", poNumber);
            formData.append("PaymentType", paymentType);
            var i = 0;
            // Reset validation flags
            requestJob.data.forEach((_, index) => {
                changeRequestJob(index, "emailIsFilled", false);
                changeRequestJob(index, "applicationNoIsFilled", false);
                changeRequestJob(index, "nameIsFilled", false);
                changeRequestJob(index, "emailFormatInvalid", false);
                changeRequestJob(index, "applicationNoInvalid", false);
                changeRequestJob(index, "applicationNoMinLength", false);
                changeRequestJob(index, "applicationNoStartWith01", false);
                changeRequestJob(index, "mobileIsFilled", false);
                changeRequestJob(index, "genderIsFilled", false);
            });

            let isFilled = false;
            requestJob.data.forEach(({ email, applicationNo, name, mobile, gender }, index) => {
                if (!email) {
                    isFilled = true;
                    changeRequestJob(index, "emailIsFilled", true);
                } else if (!emailRegex.test(email)) {
                    isFilled = true;
                    changeRequestJob(index, "emailFormatInvalid", true);
                }
                if (!applicationNo) {
                    isFilled = true;
                    changeRequestJob(index, "applicationNoIsFilled", true);
                } else if (!numberRegex.test(applicationNo)) {
                    isFilled = true;
                    changeRequestJob(index, "applicationNoInvalid", true);
                } else if (!applicationNo.startsWith('01')) {
                    isFilled = true;
                    changeRequestJob(index, "applicationNoStartWith01", true);
                } else if (applicationNo.length < 20) {
                    isFilled = true;
                    changeRequestJob(index, "applicationNoMinLength", true);
                } else if (applicationNo.length > 25) {
                    isFilled = true;
                    changeRequestJob(index, "applicationNoInvalid", true);
                }
                if (!name) {
                    isFilled = true;
                    changeRequestJob(index, "nameIsFilled", true);
                } else if (name.length > 100) {
                    isFilled = true;
                    changeRequestJob(index, "nameIsFilled", true);
                }
                if (!mobile) {
                    isFilled = true;
                    changeRequestJob(index, "mobileIsFilled", true);
                } else if (!numberRegex.test(mobile) || mobile.length < 7 || mobile.length > 15) {
                    isFilled = true;
                    changeRequestJob(index, "mobileInvalid", true);
                }
                if (!gender && gender !== 0) {
                    isFilled = true;
                    changeRequestJob(index, "genderIsFilled", true);
                }
                // Append each job's data to formData with index
                formData.append(`Email[${index}]`, email);
                formData.append(`ApplicationNo[${index}]`, applicationNo);
                formData.append(`Name[${index}]`, name);
                formData.append(`CenterId[${index}]`, selectedCenter?.value);
                formData.append(`Mobile[${index}]`, mobile);
                formData.append(`Gender[${index}]`, gender);
            });
            if (isFilled) {
                setRequestJobLoading(false);
                return;
            }
            console.log("formData", formData);
            const res = await apiWrapWithErrorWithData(corporateCompanyJobSaveAsDraft(formData));
            if (res.status === 400) {
                toastMessage("error", res.data.message);
                console.log("handleSaveAsDraft 400 response:", res);    
            } else if (res.status == 200 && res.data.data.isOnlinePayment && paymentType === 1) {
                toastMessage("success", res.data.message);
                history.push(`/checkout/${res.data.data.id}`)
            } else if (res.data.message === 'Job saved successfully.' || res.data.message === 'Job saved successfully') {
                toastMessage("success", res.data.message);
                history.push(`/jobs`)
            } else {
                const errorMsg = res.data && res.data.message ? res.data.message : (res.message ? res.message : "An error occurred");
                if (res.data.validations) {
                    const validationErrors = res.data.validations;
                    console.log("Validation Errors:", validationErrors);
                    toastMessage('error', validationErrors.map((err, idx) => `${err}${idx !== validationErrors.length - 1 ? '\n\n' : ''}`).join(''));
                } else {
                     toastMessage("error", errorMsg);
                }
                setShowModal(false);
                //history.push(`/jobs`)
                console.log("handleSaveAsDraft unexpected response:", res.data.validations);
            }
        } catch (error) {
            console.log("handleRequestJob:", error);
        }
        setSaveAsDraftLoading(false);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    }

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Please fill all required details
        </Tooltip>
    );

    const filesizes = (bytes, decimals = 2) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    const disableProceedButton = requestJob.data.some((row) => !row.email || !row.applicationNo || !row.name || !row.mobile || (row.gender !== 0 && row.gender !== 1));
    // Track expanded state for each row
    const [expandedRows, setExpandedRows] = useState({});
    const [docsLimit] = useState(1);
    // Toggle expanded/collapsed state for a row
    const toggleExpand = (rowIndex) => {
        setExpandedRows((prevState) => ({
            ...prevState,
            [rowIndex]: !prevState[rowIndex],
        }));
    };
    return (
        <Fragment>
            <div className="d-flex">
                <div className="me-3" style={{ width: "100%" }}>
                    <DropDown
                        isSearchable={true}
                        label={t("eidBasmati.department")}
                        placeholder={t("eidBasmati.selectDepartment")}
                        options={departmentList}
                        value={departmentId}
                        onChange={(value) => {
                            setProcessList([]);
                            handleList("department", value.value);
                            setDepartmentID(value);
                        }}
                        disabled={true}
                    />
                    {departmentIdFlag ? <span style={{ color: 'red' }}>Department is requied</span> : null}
                </div>
                <div className="me-3" style={{ width: "100%" }}>
                    <DropDown
                        isSearchable={true}
                        label={t("eidBasmati.masterProcess")}
                        placeholder={t("eidBasmati.selectMasterProcess")}
                        options={masterProcessList}
                        value={masterProcessId}
                        onChange={(value) => {
                            handleList("masterProcess", value.value);
                            setMasterProcessID(value);
                        }}
                        disabled={true}
                    />
                    {masterProcessIdFlag ? <span style={{ color: 'red' }}>Master process is requied</span> : null}
                </div>
                <div className="me-3" style={{ width: "100%" }}>
                    <DropDown
                        isSearchable={true}
                        label={t("eidBasmati.process")}
                        placeholder={t("eidBasmati.selectProcess")}
                        options={processList}
                        value={processId}
                        onChange={(value) => {
                            setProcessID(value);
                        }}
                        disabled={true}
                    />
                    {processIdFlag ? <span style={{ color: 'red' }}>Process is requied</span> : null}
                </div>
                <div className="me-3" style={{ width: "100%" }}>
                    <DropDown
                        isSearchable={true}
                        label={t("eidBasmati.biometricCenter")}
                        placeholder={t("eidBasmati.selectBiometricCenter")}
                        options={biometricCenters}
                        value={selectedCenter}
                        onChange={setSelectedCenter}
                    />
                    {selectCenterFlag ? <span style={{ color: 'red' }}>{t('eidBasmati.biometricCenterRequired')}</span> : null}
                </div>
            </div>
            <div className="d-flex">
                <div className="me-3" style={{ width: "32%" }}>
                    <label
                        className="form-label col-md-4 col-sm-2"
                        style={{ marginTop: "5px" }}
                    >
                        {t("eidBasmati.poNumber")}
                    </label>
                    <input
                        className="p-1 form-control col-md-4 col-sm-2"
                        type="text"
                        onChange={(e) => setPoNumber(e.target.value)}
                        value={poNumber}
                        placeholder={t("eidBasmati.pleaseEnterPoNumber")}
                    />
                    {poNumberFlag ? <span style={{ color: 'red' }}>{t('eidBasmati.poNumberRequired')}</span> : null}
                </div>
            </div>
            <div className="row mt-4">
                <div className="d-flex gap-3 col-md-12">
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={onAddHandler}
                    >
                        {t("eidBasmati.addRow")}
                    </button>
                    <div className="d-flex gap-3">
                        <h5>{t("eidBasmati.dataCount")} : </h5>
                        <h5>{requestJob.data.length}</h5>
                    </div>
                </div>
                <Card border="light" className="w-100 scrollable-card">
                    {requestJob.data.map((job, index) => (
                        <div key={job.id} className="row align-items-start mt-4 mx-0">
                            <div className="col-1 d-flex align-items-center justify-content-center">
                                <h6 >{index + 1}</h6>
                            </div>
                            <div className="col-md-2 col-8 mb-3 mb-md-0">
                                <div className="form-group mb-0">
                                    <label className="d-block">{t("eidBasmati.gender")}</label>
                                    <ButtonGroup className="w-100">
                                        <Button
                                            variant={job.gender === 0 ? "primary" : "outline-primary"}
                                            size="sm"
                                            onClick={() => setRequestJob((preState) => ({
                                                ...preState,
                                                data: [
                                                    ...preState.data.slice(0, index),
                                                    { ...preState.data[index], gender: 0, genderIsFilled: false },
                                                    ...preState.data.slice(index + 1),
                                                ],
                                            }))}
                                        >
                                            M
                                        </Button>
                                        <Button
                                            variant={job.gender === 1 ? "primary" : "outline-primary"}
                                            size="sm"
                                            onClick={() => setRequestJob((preState) => ({
                                                ...preState,
                                                data: [
                                                    ...preState.data.slice(0, index),
                                                    { ...preState.data[index], gender: 1, genderIsFilled: false },
                                                    ...preState.data.slice(index + 1),
                                                ],
                                            }))}
                                        >
                                            F
                                        </Button>
                                    </ButtonGroup>
                                    {job.genderIsFilled && <small className="text-danger">Gender is required</small>}
                                </div>
                            </div>
                            <div className="col-md-2 col-12 mb-3">
                                <div className="form-group ">
                                    <label htmlFor={`email-${job.id}`}>{t("eidBasmati.applicantEmail")}</label>
                                    <input
                                        id={`email-${job.id}`}
                                        name="email"
                                        type="email"

                                        className="form-control form-control-sm"
                                        value={job.email || null}
                                        onChange={onChange(index)}
                                        placeholder="e.g.test@gmail.com"
                                    />
                                    {job.emailIsFilled && <small className="text-danger">Applicant Email is required</small>}
                                    {job.emailFormatInvalid && !job.emailIsFilled && (
                                        <small className="text-danger">Invalid email format</small>
                                    )}
                                </div>
                            </div>

                            <div className="col-md-2 col-12 mb-3 mb-md-0">
                                <div className="form-group mb-0">
                                    <label htmlFor={`applicationNo-${job.id}`}>{t("eidBasmati.applicationNo")}</label>
                                    <input
                                        id={`applicationNo-${job.id}`}
                                        name="applicationNo"
                                        type="text"
                                        className="form-control form-control-sm"
                                        value={job.applicationNo || null}
                                        onChange={onChange(index)}
                                        placeholder="e.g. 1234567890"
                                    />
                                    {job.applicationNoIsFilled ? (
                                        <small className="text-danger">Application No is required</small>
                                    ) : job.applicationNoInvalid ? (
                                        <small className="text-danger">Numbers only</small>
                                    ) : job.applicationNoStartWith01 ? (
                                        <small className="text-danger">Must start with 01</small>
                                    ) : job.applicationNoMinLength ? (
                                        <small className="text-danger">Min 20 characters</small>
                                    ) : null}
                                </div>
                            </div>

                            <div className="col-md-2 col-12 mb-3 mb-md-0">
                                <div className="form-group mb-0">
                                    <label htmlFor={`name-${job.id}`}>{t("eidBasmati.applicantName")}</label>
                                    <input
                                        id={`name-${job.id}`}
                                        name="name"
                                        type="text"
                                        className="form-control form-control-sm"
                                        value={job.name || null}
                                        onChange={onChange(index)}
                                        placeholder="e.g. John Doe"
                                    />
                                    {job.nameIsFilled && <small className="text-danger">Applicant Name is required</small>}
                                </div>
                            </div>

                            <div className="col-md-2 col-12 mb-3 mb-md-0">
                                <div className="form-group mb-0">
                                    <label htmlFor={`mobile-${job.id}`}>{t("eidBasmati.applicantMobile")}</label>
                                    <input
                                        id={`mobile-${job.id}`}
                                        name="mobile"
                                        type="text"
                                        className="form-control form-control-sm"
                                        value={job.mobile || null}
                                        onChange={onChange(index)}
                                        placeholder="e.g. 9876543210"
                                    />
                                    {job.mobileIsFilled ? (
                                        <small className="text-danger">Applicant Mobile is required</small>
                                    ) : job.mobileInvalid ? (
                                        <small className="text-danger">Invalid mobile number</small>
                                    ) : null}
                                </div>
                            </div>



                            {/* Remove Button */}
                            <div className="col-md-1 col-12 d-flex align-items-center justify-content-center mt-3">
                                <button
                                    type="button"
                                    className="btn btn-danger btn-sm"
                                    onClick={() => onRemoveHandler(index)}
                                    disabled={requestJob.data.length === 1}
                                    title="Remove applicant"
                                >
                                    <MdRemoveCircle size={22} />
                                </button>
                            </div>
                        </div>
                    ))}
                </Card>

                <div className="d-flex justify-content-end">
                    <div className="d-flex justify-content-end m-3">
                        {disableProceedButton ? (
                            <OverlayTrigger overlay={renderTooltip}>
                                <span className="d-inline-block">
                                    <button className="btn btn-primary" onClick={handleSubmit} disabled={disableProceedButton}>
                                        {t("eidBasmati.proceed")}
                                    </button>
                                </span>
                            </OverlayTrigger>
                        ) : (
                            <button className="btn btn-primary" onClick={handleSubmit} disabled={disableProceedButton}>
                                {t("eidBasmati.proceed")}
                            </button>
                        )}
                    </div>
                </div>
            </div>

            <Modal show={showModal}>
                <ModalHeader>
                    <Modal.Title>
                        QUATATIONAL DETAILS
                    </Modal.Title>
                    <button className="btn btn-primary" onClick={handleCloseModal}><FaWindowClose /></button>
                </ModalHeader>
                <ModalBody>
                    {quotation.headers.length ? (
                        <div className="m-3" >
                            <BasicTable headers={quotation.headers} data={quotation.rows} />
                        </div>
                    ) : null}
                    <div>
                    </div>
                    <div className="w-100">
                        <DropDown
                            label={t("eidBasmati.selectPaymentType")}
                            isSearchable={true}
                            placeholder={"Online"}
                            options={paymentTypeOptions}
                            onChange={(value) => {
                                setPaymentType(value.value);
                            }}
                        />
                    </div>
                    <p style={{ color: 'red' }}><b>{validationError}</b></p>
                </ModalBody>

                <ModalFooter>
                    <div className="d-flex gap-3 justify-content-end">
                        <LoadingButton
                            isLoading={saveAsDraftLoading}
                            onChange={handleSaveAsDraft}
                        >
                            {t('eidBasmati.saveAsDraft')}
                        </LoadingButton>
                        <LoadingButton
                            isLoading={requestJobLoading}
                            onChange={handleRequestJob}
                        >
                            {t('eidBasmati.requestJob')}
                        </LoadingButton>
                    </div>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}

export default EmiratesIdCreate;
